module.exports = __webpack_public_path__ + "img/v_hearts.ec8dfba0.png";